// src/utils/dropdownData.ts
// Dropdown data for Risk Assessment forms
// These match the ISO27001 categories in the adminStore

export const assetCategoryOptions = [
  'Human Resources',
  'Infrastructure',
  'IT and communication equipment',
  'Network',
  'Other document and data (in electronic and other forms)',
  'Software and databases',
  'Third party service'
];

export const threatsByCategory: Record<string, string[]> = {
  'Human Resources': ['Social engineering', 'Insider threat', 'Human error', 'Lack of awareness', 'Unauthorized access', 'Negligence'],
  'Infrastructure': ['Natural disaster', 'Fire', 'Water damage', 'Power failure', 'Physical damage', 'Unauthorized physical access'],
  'IT and communication equipment': ['Malware', 'Ransomware', 'Hardware failure', 'Theft', 'Unauthorized access', 'Equipment damage'],
  'Network': ['Network attack', 'DDoS', 'Man-in-the-middle', 'Unauthorized access', 'Network failure', 'Configuration errors'],
  'Other document and data (in electronic and other forms)': ['Data breach', 'Data loss', 'Unauthorized disclosure', 'Data corruption', 'Accidental deletion'],
  'Software and databases': ['SQL Injection', 'XSS', 'Software vulnerability', 'Unpatched systems', 'Database breach', 'Data corruption'],
  'Third party service': ['Service disruption', 'Data breach', 'Contract breach', 'SLA violation', 'Vendor failure']
};

export const vulnerabilityOptions = [
  'Unpatched systems',
  'Weak passwords',
  'No MFA',
  'Outdated software',
  'Misconfiguration',
  'Lack of encryption',
  'No monitoring',
  'Lack of policies',
  'No training',
  'Poor processes',
  'Insufficient resources',
  'No incident response plan',
  'Poor physical security',
  'No access controls',
  'Lack of surveillance',
  'Single point of failure',
  'No environmental controls',
  'Lack of awareness',
  'Social engineering susceptibility',
  'Poor password practices',
  'No security culture'
];

export const getThreatsForCategory = (category: string): string[] => {
  return threatsByCategory[category] || [];
};
